import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { useTableReducer } from '@base'
import { Table } from '@baseV2'
import { DRAWER_TYPES, strings, TenderMasterFilters } from '@constants'
import { getAllTenderMaster } from '@data'
import { useForceUpdate } from '@hooks'
import { toggleDrawer } from '@data/state/action/root'
import { FullHeightPageLevelTableWrapper } from '@pages/Admin/Tenderbook/styles'

const ROWS_PER_PAGE = 10

const TenderMaster = () => {
	const globalDispatch = useDispatch()
	const [state, dispatch, actions] = useTableReducer(TenderMasterFilters)

	const [forceUpdate, update] = useForceUpdate()

	useEffect(() => {
		if (state.loading) return

		dispatch(actions.fetchTableDataProgress())
		getAllTenderMaster({ ...state.query.filters, page: state.query.page, size: ROWS_PER_PAGE })
			.then((response) => {
				dispatch(actions.fetchTableDataSuccess(response.data, response.count))
			})
			.catch((error) => {
				dispatch(actions.fetchTableDataFailure(error))
			})
			.finally(() => {})
	}, [state.query, forceUpdate])

	// Sorting stays off: the table is server-paginated, so v2's built-in sort would only
	// reorder the page in view.
	const columns = useMemo(() => {
		return [
			{ label: strings('entity'), key: 'entity', sortable: false, mobile: true },
			{ label: strings('name'), key: 'name', sortable: false, mobile: true },
			{ label: strings('parent_name'), key: 'parent_name', sortable: false, mobile: true },
			{ label: strings('popular'), key: 'is_popular', sortable: false, renderer: (data) => (data ? 'TRUE' : 'FALSE'), mobile: true },
			{ label: strings('keywords'), key: 'keywords', sortable: false, renderer: (data) => data?.join(', '), mobile: true },
		]
	}, [])

	const changePageHandler = (next = true) => {
		dispatch(actions.changePage(next))
	}

	const onRowClickHandle = (row) => {
		globalDispatch(toggleDrawer(true, DRAWER_TYPES.EDIT_TENDER_MASTER, { label: strings('edit_tender_master'), data: row, update }))
	}

	return (
		<FullHeightPageLevelTableWrapper>
			<Table
				data={state.data}
				columns={columns}
				loading={state.loading}
				rowsToDisplay={ROWS_PER_PAGE}
				totalItemCount={state.total_count}
				page={state.query.page}
				onPageChange={changePageHandler}
				onRowClick={onRowClickHandle}
				emptyState={{ text: 'No tender master records found' }}
				scrollable
			/>
		</FullHeightPageLevelTableWrapper>
	)
}

export default TenderMaster
